<i18n>
{
    "en_US": {
        "connection": "Connection",
        "forgot-password": "Forgot password?",
        "login": "Login",
        "missing-username-password": "A username and password must be present",
        "register": "Register a new account",
        "remember": "Remember me",
        "sign-in": "Sign in"
    },
    "fr_FR": {
        "connection": "Connexion",
        "forgot-password": "Mot de passe oublié ?",
        "login": "Identifiant",
        "missing-username-password": "L'identifiant et le mot de passe sont nécessaires",
        "register": "Créer un compte",
        "remember": "Se souvenir de moi",
        "sign-in": "Se connecter"
    }
}
</i18n>

<template>
    <form v-on:submit.prevent="login">
        <h1 class="text-left" v-text="$t('connection')"></h1>

        <slot name="flashes" />

        <div class="form-group bmd-form-group">
            <label for="inputUsername" class="bmd-label-floating" v-text="$t('login')"></label>
            <input type="text" class="form-control bmb-control" id="inputUsername" v-model="username" v-bind:disabled="pending.login" required />
        </div>

        <input-password-reveal v-model="password" v-bind:disabled="pending.login" />

        <div class="container-fluid">
            <div class="row">
                <div class="col-6">
                    <div class="checkbox mb-3 text-left">
                        <label class="remember">
                            <input type="checkbox" value="remember-me" v-bind:disabled="pending.login" checked> {{$t("remember")}}
                        </label>
                    </div>
                </div>
                <div class="col-6 text-right">
                    <a class="href" v-on:click="passwordLost" v-text="$t('forgot-password')"></a>
                </div>
            </div>
        </div>
        <button class="btn btn-lg btn-primary btn-block" type="submit" v-bind:disabled="isAllowedButton">
            <loader-basic-spinner v-if="pending.login" />
            <a v-else v-text="$t('sign-in')"></a>
        </button>
        <div class="register text-right">
            <a class="href" v-on:click="register" v-text="$t('register')"></a>
        </div>
    </form>
</template>

<script>
    import InputPasswordReveal from "inputs/PasswordReveal";
    import LoaderBasicSpinner from "loaders/BasicSpinner";
    import { mapState, mapMutations, mapActions } from "vuex";

    export default {
        name: "Login",
        data: function() {
            return {
                username: "",
                password: ""
            };
        },
        components: {
            InputPasswordReveal,
            LoaderBasicSpinner
        },
        mounted: function() {
            $(this.$el).bootstrapMaterialDesign();
            $(this.$el).find("#inputUsername").focus();
        },
        computed: {
            isAllowedButton: function() {
                return this.pending.login || !this.username || !this.password;
            },
            ...mapState("user", ["pending"])
        },
        methods: {
            passwordLost: function() {
                this.$router.push({ name: "password-lost" });
            },
            register: function() {
                this.$router.push({ name: "register" });
            },
            login: function() {
                if(!this.username && !this.password) {
                    this.addFlash({
                        type: "error",
                        message: this.$t("missing-username-password"),
                        onlyCurrentRoute: true
                    });
                    return;
                }

                // Do login
                this.actionLogin({
                    login: this.username,
                    password: this.password
                })
                    .then(function() {
                        this.$Progress.increase(30);
                        if (this.$route.query && this.$route.query.redirect) {
                            this.$router.push(this.$route.query.redirect);
                        } else {
                            this.$router.push({ name: "home" });
                        }
                    }.bind(this))
                    .catch(function() {});
            },
            ...mapActions("user", {
                actionLogin: "login"
            }),
            ...mapMutations("flash", ["addFlash"])
        }
    }
</script>

<style scoped>
    h1 {
        margin-top: 0;
        margin-bottom: 0;
        color: #666;
        font-weight: 300;
        font-size: 20px;
    }
    .bmb-form-group {
        padding-top: 1.3rem !important;
    }
    button {
        margin-bottom: 0;
        margin-top: 10px;
        font-weight: 100;
        font-size: 18px !important;
        line-height: 1.3333333333;
    }
    .bmd-label-floating {
        left: 0;
    }
    .form-group label {
        font-weight: bold;
        font-size: 14px;
    }
    .container-fluid {
        margin-top: 30px;
    }
    .col-6 {
        padding: 0;
    }
    .remember {
        color: rgb(118, 131, 143);
        font-weight: 100;
        font-size: 14px !important;
    }
    .register {
        margin-top: 20px;
    }
    .register a {
        font-size: 0.8em;
    }
    .href {
        color: #3e8ef7;
        font-weight: 100;
        font-size: 14px;
        cursor: pointer;
    }
</style>